import { AudioProperty, careKeepStreaming } from '../../../serverApi';

const keepStreamingSignalInterval = 5000;

type ActiveConnectionStatus =
  | { connected: false }
  | {
      connected: true;
      audioProperty: AudioProperty;
      contextEventId?: null | number;
      sensorId: string;
    };

/**
 * This class sends keepStreaming signals at regular intervals
 * to the backend while the SIP/audio connection is established.
 */
export class WebRtcKeepStreamingSignalHandler {
  private intervalId: number | null = null;
  private status: ActiveConnectionStatus = { connected: false };

  public update(status: ActiveConnectionStatus) {
    this.status = status;

    /**
     * Stop any currently running timer.
     */
    if (this.intervalId) {
      window.clearInterval(this.intervalId);
      this.intervalId = null;
    }

    /**
     * If we don't currently have a connection, there's nothing to do.
     */
    if (status.connected) {
      this.sendSignal();
      this.intervalId = window.setInterval(() => {
        this.sendSignal();
      }, keepStreamingSignalInterval); // Every 5 seconds
    }
  }

  async sendSignal() {
    if (this.status.connected) {
      await careKeepStreaming({
        sensorId: this.status.sensorId,
        audioProperty: this.status.audioProperty,
        contextEventId: this.status.contextEventId,
      });
    }
  }
}
